import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { COLORS } from "../../constants";

type SectionTitleProps = {
    text: string,
    eyebrow?: string,
    intro?: ReactNode,
    tone?: 'dark' | 'light',
    align?: 'left' | 'center',
    as?: 'h1' | 'h2',
}

function SectionTitle({ text, eyebrow, intro, tone = 'light', align = 'left', as = 'h2' }: SectionTitleProps) {
    const dark = tone === 'dark'
    return (
        <Box sx={{ mb: { xs: 4, md: 6 }, maxWidth: 760, mx: align === 'center' ? 'auto' : 0, textAlign: align }}>
            {eyebrow && (
                <Typography variant="overline" component="p" sx={{ color: dark ? COLORS.accent : COLORS.accentOnLight, mb: 1 }}>
                    {eyebrow}
                </Typography>
            )}
            <Typography variant={as === 'h1' ? 'h1' : 'h2'} component={as} sx={{ color: dark ? COLORS.white : COLORS.black }}>
                {text}
            </Typography>
            {intro && (
                <Typography sx={{ mt: 2, color: dark ? COLORS.mutedOnDark : 'text.secondary', fontSize: { xs: '1.05rem', md: '1.15rem' } }}>
                    {intro}
                </Typography>
            )}
        </Box>
    );
}

export default SectionTitle;
